export class submitOTPLabel_HN {

    dialog: {
        refNumber: string;
        message: string;
        otp: string;
        number: string;
        regenerate: string;
        successDisplay: string;
        send: string;
        verifyMobile: string;
        verifyEmail: string;
        verifyEmailMasked: string;
        verifiedEmailSuccess: string;
        verifiedMobileSuccess: string;
    }

    button: {
        submit: string;
        resend: string;
        submitLater: string;
        okText: string;
        regenerate: string;
    }

    constructor() {

        this.dialog = {
            refNumber: "डीएलपी  संदर्भ संख्या:",
            message: "उत्पन्न होता है। आप बाद में कभी भी उद्धरण प्राप्त करने के लिए अनुमोदन प्रस्तुत कर सकते हैं।",
            otp: "कोटेशन नंबर के लिए ओटीपी उत्पन्न किया गया है:",
            // number: "and sent to customer’s mobile number ending with ******",
            number: "और आपके मोबाइल नंबर पर भेज दिया गया है जो नंबर के साथ समाप्त होता है ******",
            regenerate: "ओटीपी अधिकतम पुन: प्रयास की अंतिम सीमा तक पहुंच गया, कृपया पुन: उत्पन्न करें",
            successDisplay: "उद्धरण प्रस्तुत किया गया है। आवेदन संख्या है",
            send: "",
            verifyMobile: "वन टाइम पासवर्ड आपके मोबाइल नंबर पर साझा कर दिया गया है जो नंबर के साथ समाप्त होता है ******",
            verifyEmail: "वन टाइम पासवर्ड आपकी ईमेल आईडी पर साझा कर दिया गया है",
            verifyEmailMasked: "****",
            verifiedEmailSuccess: "ईमेल आईडी को सफलतापूर्वक सत्यापित किया गया",
            verifiedMobileSuccess: "मोबाइल नंबर सफलतापूर्वक सत्यापित किया गया",
        }
        this.button = {
            submit: "अभी ओटीपी सबमिट करें",
            resend: "ओटीपी पुनः भेजें",
            submitLater: "ओटीपी बाद में सबमिट करें",
            okText: "ठीक है",
            regenerate: "ओटीपी फिर से जनरेट करें"
        }
    }
}
